module.exports = {
          srcSet: "/_next/static/images/contact_worldmap-1216-25fdf17c09774345138459a37826666b.jpg"+" 1216w",
          images:[ {path: "/_next/static/images/contact_worldmap-1216-25fdf17c09774345138459a37826666b.jpg",width: 1216,height: 675}],
          src: "/_next/static/images/contact_worldmap-1216-25fdf17c09774345138459a37826666b.jpg",
          toString:function(){return "/_next/static/images/contact_worldmap-1216-25fdf17c09774345138459a37826666b.jpg"},
          
          width: 1216,
          height: 675
        }